import React, { useState } from "react";
import OtbRecapViz from "./OtbRecapViz.component";
import { OtbRecapTableReport } from "./OtbRecapTableReport.component";

interface OtbRecapBaseProps {
    clientId: string | number;
    epochMonth: number | null;
}

const OtbRecapBase = ({ clientId, epochMonth }: OtbRecapBaseProps) => {
    const [view, setView] = useState<"viz" | "table">("viz");

    return (
        <div className="w-full h-full flex flex-col">
            <div className="flex justify-end mb-4 mr-4">
                {/* <button
                    className={`px-4 py-2 rounded-l ${view === "viz" ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-700"}`}
                    onClick={() => setView("viz")}
                >
                    Visualization
                </button>
                <button
                    className={`px-4 py-2 rounded-r ${view === "table" ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-700"}`}
                    onClick={() => setView("table")}
                >
                    Table
                </button> */}
            </div>
            <div className="flex-1">
                {/* {view === "viz" ? (
                    <OtbRecapViz clientId={clientId} epochMonth={epochMonth} />
                ) : ( */}
                {epochMonth !== null && (
                    <OtbRecapTableReport clientId={clientId} epochMonth={epochMonth} />
                )}
                {/* )} */}
            </div>
        </div>
    );
};

export default OtbRecapBase;
